
/**
 * Fxxl Google Tagmanager
 *
 * Filename: gtm.js
 *
 * @category  Fahrradxxl
 * @package   Generell
 * @author    Janik Kemnade <j.kemnade@fahrrad-xxl.de>
 * @copyright 2024 Fahrrad-xxl.de
 */

import FxxlCore from '@fxxl/core';
import FxxlError from '@fxxl/error';


export default class FxxlGTM {
    // TODO: Diese Events werden mit zukünftigen Tickets noch besser positioniert und verarbeitet
    // Statics
    // static pushChunkSize                        = 10
    //
    // static classElementArtikelClick             = 'gtm__artikel--click';
    // static classArtikelDetailAddToCart          = 'gtm__artikel_form--addtocart';
    // static classWarenkorbDetailRemoveFromCart   = 'gtm__artikel--removefromcart';
    //
    // static eventProductClick                    = 'EECproductClick';
    // static eventProductImpression               = 'EECproductImpression';
    // static eventProductAddToCart                = 'EECaddToCart';
    // static eventProductRemoveToCart             = 'EECremoveFromCart';
    static eventNameCheckout4ChangePaymentMethod    = 'fxxl_checkout4--change_payment_method';
    static eventNameCheckout7PresentPaymentMethod   = 'fxxl_checkout7--present_payment_method';
    static eventNameCheckout4LeasingPopup           = 'fxxl_checkout4--submit_leasingautomation_popup_message';

    /* Static Variables - GLOBALS
     * ------------------------------------------------------------------------ */
    static ERROR_MESSAGES_PREFIX = 'FxxlGTM';
    static get ERROR_MESSAGE() {
        return {
            INSTANCE_EXISTS: `${FxxlGTM.ERROR_MESSAGES_PREFIX}: Call: An Instance exists`,
            PARAMETER_WRONG: `${FxxlGTM.ERROR_MESSAGES_PREFIX}: Parameter wrong`
        };
    }

    static get EVENT() {
        return {
            NEWSLETTER_POPUP: {
                SHOW:   'fxxl_newsletter_popup--show',
                HIDE:   'fxxl_newsletter_popup--hide',
                SUBMIT: 'fxxl_newsletter_popup--submit',
            }
        };
    }


    /* Constructor
     * ------------------------------------------------------------------------ */
    constructor() {
        // Exit Criteria: Only one Instance acceptable
        if (FxxlGTM._instance) {
            new FxxlError(FxxlGTM.ERROR_MESSAGE.INSTANCE_EXISTS);
            return;
        }

        FxxlGTM._instance = this;

        // Classnames & Ids


        // Variables


        // Init
        this.initViewHandler();

        // Other
    }

    /* # --- Helper ---------------------------------------------------------------------------- */




    /* # --- Private Methods ------------------------------------------------------------------- */

    /* ## --- Global Calls -------------------------------------------- */

    /* ## --- Handle Views -------------------------------------------- */
    initViewHandler() {
        if (!_vwTypeName || !_vwName) {
            return;
        }

        const viewTypeName      = _vwTypeName.charAt(0).toUpperCase() + _vwTypeName.slice(1) // z.B. Artikel
        const viewName          = _vwName.charAt(0).toUpperCase() + _vwName.slice(1) // z.B. Detail
        const viewFunctionName  = `initViewHandler${viewTypeName}${viewName}`; // // z.B. initViewHandlerArtikelDetail

        if (this[viewFunctionName]) {
            this[viewFunctionName]();
        }
    }

    // Checkout 4 - Payment
    initViewHandlerWarenkorbCheckout4() {
        this.initCheckout4ChangePaymentMethod();
    }

    /*
     * Based on:
     * - 420_checkout.js -> setupCheckout -> collapsibleHeader utilisation
     * - 420_checkout.js -> selectLeasinganbieter utilisation
     */
    initCheckout4ChangePaymentMethod() {
        const checkout4 = document.querySelector('.fxxl-warenkorb-checkout4');
        if (!checkout4) {
            return;
        }

        const collapsibleHeader = checkout4?.querySelectorAll('.collapsible-header');
        const selectLeasinganbieter = checkout4?.querySelector('#leasinganbieter');

        // Handle Basic Payment Method Selecting
        collapsibleHeader.forEach((header) => {
            const headerInput = header?.querySelector('input[name="b_zahlungsweise_id"]');
            let paymentName = headerInput?.dataset?.name;
            let paymentIdentifier = headerInput?.dataset?.zw;

            header.addEventListener('click', () => {
                // Check if Leasing Partner Input was selected
                if (headerInput?.classList.contains('radio-leasinganbieter')) {
                    paymentName = selectLeasinganbieter?.options
                        ?.[selectLeasinganbieter.selectedIndex]?.textContent?.trim();
                    paymentIdentifier = 'leasinganbieter';
                }

                // Send Data
                FxxlGTM.eventCheckout4ChangePaymentMethod(paymentName, paymentIdentifier);
            });
        });

        // Handle Leasing Partner Selecting
        if (selectLeasinganbieter) {
            let selectedLeasinganbieter = undefined;

            selectLeasinganbieter.addEventListener( 'change', function() {
                // Send && IF = Remove the possibility for double Event pushs
                if (this.value !== selectedLeasinganbieter) {
                    const paymentIdentifier = 'leasinganbieter';
                    const paymentName = this?.options?.[this.selectedIndex]?.textContent?.trim();
                    FxxlGTM.eventCheckout4ChangePaymentMethod(paymentName, paymentIdentifier);

                    selectedLeasinganbieter = this.value;
                }
            });
        }
    }


    /* # --- Static / Public Methods ----------------------------------------------------------- */

    /* ## --- Basic Send-Data Functions ------------------------------- */
    /*
        Folgende Funktion stehen aktuell als Prototyp zur Verfügung.
        Wird zu einem späteren Zeitpunkt eine insgesamtere Umsetzung einer Bearbeitung von GTM Code angestrebt,
        können diese Funktionen genutzt werden.
        Ersetzt hiermit soll semtliches aus "/custom/module/public/fxxl3/assets/js/400_gtm.js".
        Genau gemeint sind:
        - pushOnLoad
        - pushOnClick
        - pushOnVisible
        - pushCustomerData
     */

    /**
     * Push to DataLayer on Load
     *
     * @param {string} event
     * @param {object} data
     */
    // static pushOnLoad(event, data) {
    //     if (typeof event !== 'string' || typeof data !== 'object') {
    //         new FxxlError('Parameter wrong format');
    //         return;
    //     }
    //
    //     data.event = event;
    //
    //     if (dataLayer) {
    //         dataLayer.push(data);
    //     }
    // }

    /**
     * Push to DataLayer on Click
     *
     * @param {string} event
     * @param {object} data
     */
    // static pushOnClick(event, data) {
    //     if (typeof event !== 'string' || typeof data !== 'object') {
    //         new FxxlError('Parameter wrong format');
    //         return;
    //     }
    //
    //     data.event = event;
    //
    //     if (dataLayer) {
    //         dataLayer.push(data);
    //     }
    // }

    /**
     * Push to DataLayer if Element is visible
     *
     * @param {string} event
     * @param {string} elementClass
     * @param {object} data
     */
    // static pushOnVisible(event, elementClass, data) {
    //     if (typeof event !== 'string' || typeof elementClass !== 'string' || typeof data !== 'object') {
    //         new FxxlError('Parameter wrong format');
    //         return;
    //     }
    //
    //     const pushLockClass = "gtm_datalayer_push";
    //     const elements = document.querySelectorAll(`.${elementClass}`);
    //
    //     document.addEventListener('scroll', () => {
    //         elements.forEach(element => {
    //             if (elementInViewport(element) && !element.classList.contains(pushLockClass)) {
    //                 element.classList.add(pushLockClass);
    //                 FxxlGTM.pushOnClick(event, data);
    //             }
    //         });
    //     });
    // }

    /**
     * Push Customer Data to DataLayer
     *
     * @param {object} data
     */
    // static pushCustomerData(data) {
    //     if (typeof data !== 'object') {
    //         new FxxlError('Parameter wrong format');
    //         return;
    //     }
    //
    //     const customerData = {
    //         'customer': {
    //             ...data?.user       && { user:      data.user       },
    //             ...data?.cart       && { cart:      data.cart       },
    //             ...data?.wishlist   && { wishlist:  data.wishlist   }
    //         }
    //     };
    //
    //     FxxlGTM.pushOnLoad('customerData', customerData);
    // }

    /* ## --- Checkout 4 Event Handling Functions --------------------- */
    /**
     * Push newly selected Payment Method Data to the DataLayer
     * Works with:
     * - checkout -> 420_checkout.js -> setCheckout4FormValidation()
     *
     * @param {string} paymentMethodName
     * @param {string} paymentMethodIdentifier
     */
    static eventCheckout4ChangePaymentMethod(paymentMethodName, paymentMethodIdentifier = '') {
        // No Error here, because choosing the Leasing Input set paymentMethodName to undefined
        if (!paymentMethodName) {
            return;
        }

        dataLayer?.push({
            event: FxxlGTM.eventNameCheckout4ChangePaymentMethod,
            dataPaymentMethod: {
                name: paymentMethodName,
                identifier: paymentMethodIdentifier
            }
        });
    }

    /**
     * Push Leasing-Popup Data depending on given Modal Content to the DataLayer
     *
     * @param {object} modal
     * @param {string} email
     */
    static eventCheckout4ShowLeasingPopup(modal, email = '') {
        if (typeof modal !== 'object') {
            new FxxlError('GTM: Parameter wrong');
            return;
        }

        const leasings = document.querySelector('select#leasinganbieter');
        const selectedLeasingDescription = leasings?.options?.[leasings?.selectedIndex]?.textContent?.trim();
        const popupMessage = modal?.querySelector('.fxxl-leasingautomation-modal-content__text')?.textContent;

        dataLayer?.push({
            event: FxxlGTM.eventNameCheckout4LeasingPopup,
            dataLeasingPopup: {
                leasingDescription: selectedLeasingDescription || '',
                email: email,
                message: popupMessage || ''
            }
        });
    }

    /**
     * This function sends the "Newsletter Popup Show"-Event to the DataLayer / GTM.
     *
     * @returns {void}
     */
    static sendEventFxxlNewsletterPopupShow() {
        dataLayer?.push({
            event: FxxlGTM.EVENT.NEWSLETTER_POPUP.SHOW,
            dataNewsletterPopup: {}
        });
    }

    /**
     * This function sends the "Newsletter Popup Hide"-Event to the DataLayer / GTM.
     *
     * @returns {void}
     */
    static sendEventFxxlNewsletterPopupHide() {
        dataLayer?.push({
            event: FxxlGTM.EVENT.NEWSLETTER_POPUP.HIDE,
            dataNewsletterPopup: {}
        });
    }

    /**
     * This function sends the "Newsletter Popup Submit"-Event to the DataLayer / GTM.
     * Also fills given Parameter to the Event-Object.
     *
     * @param {string} email
     * @param {string} newsletterAgreementText
     * @returns {void}
     */
    static sendEventFxxlNewsletterPopupSubmit(email, newsletterAgreementText) {
        if (typeof email !== 'string' || typeof newsletterAgreementText !== 'string') {
            new FxxlError(FxxlGTM.ERROR_MESSAGE.PARAMETER_WRONG);
            return;
        }

        dataLayer?.push({
            event: FxxlGTM.EVENT.NEWSLETTER_POPUP.SUBMIT,
            dataNewsletterPopup: {
                email: email,
                newsletterAgreementText: newsletterAgreementText
            }
        });
    }

}